import state from "./moduleDocumentManagementState";
import mutations from "./moduleDocumentManagementMutations";
import actions from "./moduleDocumentManagementActions";

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
